import FakeDashboardApi from "./FakeDashboardApi";
import RealDashboardApi from "./RealDashboardApi";

class DashboardApi {
    fakeApi = false;
    fake = new FakeDashboardApi();
    real = new RealDashboardApi();

    getTopTenShops = ({ today }: { today: string }) => {
        if (this.fakeApi) {
            return this.fake.getTopTenShops();
        } else {
            return this.real.getTopTenShops({ today });
        }
    };

    getBookmarkedShops = () => {
        if (this.fakeApi) {
            return this.fake.getBookmarkedShops();
        } else {
            return this.real.getBookmarkedShops();
        }
    };

    getTopThreeSales = ({ today }: { today: string }) => {
        if (this.fakeApi) {
            return this.fake.getTopThreeSales();
        } else {
            return this.real.getTopThreeSales({ today });
        }
    };
}

export default DashboardApi;
